/**
 * Stable CSS class names for E2E — Return / Product table (per-product card).
 */
export const RPT = {
    root: 'return-product-table',
    paper: 'return-product-table__paper',
    content: 'return-product-table__content',

    image: 'return-product-table__image',
    imageBig: 'return-product-table__image--big',

    tableContainer: 'return-product-table__table-container',
    table: 'return-product-table__table',
    tableHead: 'return-product-table__table-head',
    tableHeadRow: 'return-product-table__table-head-row',
    tableHeadCell: 'return-product-table__table-head-cell',

    tableBody: 'return-product-table__table-body',
    tableBodyRow: 'return-product-table__table-body-row',
    tableBodyCell: 'return-product-table__table-body-cell',

    statusChip: 'return-product-table__status-chip',

    reasonFormControl: 'return-product-table-input__reason-form-control',
    reasonSelectLabel: 'return-product-table-input__reason-select-label',
    reasonSelect: 'return-product-table-input__reason-select',
    reasonSelectItem: 'return-product-table-input__reason-select-item',

    quantityFormControl: 'return-product-table-input__quantity-form-control',
    quantitySelectLabel: 'return-product-table-input__quantity-select-label',
    quantitySelect: 'return-product-table-input__quantity-select',
    quantitySelectItem: 'return-product-table-input__quantity-select-item',
} as const;

export const rptCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

